<template>
  <div id="results" class="box">
    <div v-if="isLoading">
      Loading...
      <i class="fa fa-spinner fa-2x"></i>
    </div>
    <div v-else>
      <h1 class="title">Your test results</h1>
      <div class="columns is-multiline">
        <!-- todo: convert to component -->
        <div class="tc-card column tc-is-one-third">
          <div class="card-content">
            <br />
            <div class="content">
              <div class="is-size-4">
                <b>{{ testResults.phq9Result.severity }}</b>
              </div>
              <br />
              <!-- <div class='is-4'>Score: {{ testResults.phq9Result.score }}</div> -->
              <!-- <br> -->
              <div class="is-4">{{ testResults.phq9Result.description }}</div>
            </div>
          </div>
        </div>

        <div class="tc-card column tc-is-one-third">
          <div class="card-content">
            <br />
            <div class="content">
              <div class="is-size-4">
                <b>{{ testResults.gad7Result.severity }}</b>
              </div>
              <br />
              <!-- <div class='is-4'>Score: {{ testResults.gad7Result.score }}</div> -->
              <!-- <br> -->
              <div class="is-4">{{ testResults.gad7Result.description }}</div>
            </div>
          </div>
        </div>

        <div class="tc-card column tc-is-one-third">
          <div class="card-content">
            <br />
            <div class="content">
              <!-- <div class='is-size-4'><b>{{ testResults.cape15Result.distressSeverity }}</b></div> -->
              <!-- <div class='is-4'>Test Score: {{ testResults.cape15Result.testScore }}</div> -->
              <!-- <br> -->
              <div class="is-size-4">
                <b>{{ testResults.cape15Result.testSeverity }}</b>
              </div>
              <br />
              <div class="is-4" v-html="testResults.cape15Result.description"></div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <p>Thank you taking the tests. Wish you the best.</p>
      <br />
      <p>This is a project by TrustCircle &amp; SCARF.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'results',
  data() {
    return {
      testResults: [],
      isLoading: true,
      testId: parseInt(this.$temp.testId, 10),
      sessionCode: this.$temp.sessionCode,
    };
  },
  methods: {
    getResult() {
      this.$http
        .post('/scarf/getResults', {
          testId: this.testId,
          sessionCode: this.sessionCode,
        })
        .then((res) => {
          if (res.data.ok === 1) {
            console.log('Results:', res.data);
            this.testResults = res.data;
            this.isLoading = false;
            this.$temp.endSession();
          } else {
            this.$toast.open(res.data.msg);
          }
        });
    },
  },
  created() {
    this.getResult();
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Results.vue